import {
	AlertTriangle,
	HelpCircle,
	TriangleAlert,
	Wrench,
	XCircle,
	Zap,
} from "lucide-react";
import type React from "react";
import type { TriageCategory } from "@/services/testing";

export const TRIAGE_META: Record<
	TriageCategory,
	{ label: string; color: string; icon: React.ReactNode }
> = {
	// Text shades are theme-aware: a dark shade (readable on the pale `/10` tint in LIGHT mode) plus a
	// light `dark:` shade (readable on the tint in DARK mode). Single-shade colors washed out in one mode.
	SELECTOR_DRIFT: {
		label: "Selector drift",
		color: "border-warning/50 bg-warning/10 text-warning-strong",
		icon: <Wrench className="h-3 w-3" />,
	},
	VIEW_RENDER_GAP: {
		label: "View render gap",
		color: "border-warning/50 bg-warning/10 text-warning-strong",
		icon: <Wrench className="h-3 w-3" />,
	},
	TIMING_ASYNC: {
		label: "Async timing",
		color: "border-cyan-500/50 bg-cyan-500/10 text-cyan-700 dark:text-cyan-300",
		icon: <Zap className="h-3 w-3" />,
	},
	PAGE_LAYOUT_MISMATCH: {
		label: "Page layout",
		color: "border-warning/50 bg-warning/10 text-warning-strong",
		icon: <Wrench className="h-3 w-3" />,
	},
	MISSING_SETUP_DATA: {
		label: "Missing setup",
		color: "border-blue-500/50 bg-blue-500/10 text-blue-700 dark:text-blue-300",
		icon: <AlertTriangle className="h-3 w-3" />,
	},
	VALIDATION_RULE_BLOCK: {
		label: "Validation rule",
		color: "border-yellow-500/50 bg-yellow-500/10 text-yellow-700 dark:text-yellow-300",
		icon: <TriangleAlert className="h-3 w-3" />,
	},
	AUTOMATION_MUTATED_VALUE: {
		label: "Automation changed value",
		color: "border-purple-500/50 bg-purple-500/10 text-purple-700 dark:text-purple-300",
		icon: <Zap className="h-3 w-3" />,
	},
	FLS_DENIED: {
		label: "Field access denied",
		color: "border-destructive/50 bg-destructive/10 text-destructive-strong",
		icon: <XCircle className="h-3 w-3" />,
	},
	OBJECT_PERMISSION_DENIED: {
		label: "Object access denied",
		color: "border-destructive/50 bg-destructive/10 text-destructive-strong",
		icon: <XCircle className="h-3 w-3" />,
	},
	AMBIGUOUS_EXPECTATION: {
		label: "Ambiguous expectation",
		color: "border-primary/50 bg-primary/10 text-primary",
		icon: <HelpCircle className="h-3 w-3" />,
	},
	REAL_REGRESSION: {
		label: "Regression",
		color: "border-destructive/50 bg-destructive/10 text-destructive-strong",
		icon: <TriangleAlert className="h-3 w-3" />,
	},
	UNKNOWN: {
		label: "Needs clarification",
		color: "border-muted-foreground/50 bg-muted/20 text-muted-foreground",
		icon: <HelpCircle className="h-3 w-3" />,
	},
};
